import { render, staticRenderFns } from "./AccountLoader.vue?vue&type=template&id=d90d8ace&"
import script from "./AccountLoader.vue?vue&type=script&lang=ts&"
export * from "./AccountLoader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports